import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map, Observable, of, tap } from 'rxjs';
import { DataService } from 'src/app/shared/services/data/data.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { DashboardUser } from './auth-user.model';
import { UsersService } from '../features/users/users.service';

const endPoint = '';
@Injectable({
  providedIn: 'root',
})
export class OtpServiceService extends DataService {
  constructor(
    http: HttpClient,
    private storageService: StorageService,
    private usersService: UsersService,
    private router: Router
  ) {
    super(endPoint, http);
  }



  sendOtp(credential: {
    phone: string;
  }): Observable<void> {
    return this.post('send-otp', credential);
  }

  deleteProfile(id:string,otp:string): Observable<void> {
    return this.delete(`user/delete-profile/${id}/${otp}`);
  }

}
